export enum Actions {
  SET_NOTIFICATIONS = '@PROFILE_NOTIFICATION/SET_NOTIFICATIONS',
  SET_LOADING = '@PROFILE_NOTIFICATION/SET_LOADING'
}
